import { Collapse, List, ListItemText } from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import ExpandMore from "@mui/icons-material/ExpandMore";
import HamburgerMenuListItem from "./HamburgerMenuListItem";

const HamburgerMenuCollapsibleMenuItem = (props) => {
  const renderParentMenuItem = () => {
    return (
      <>
        <HamburgerMenuListItem
          menuItemConfig={props.menuItemConfig}
          onClick={() => props.onParentMenuItemClick(props.menuItemConfig.key)}
          selected={false}
          isParent={true}
          isDesktopView={props.isDesktopView}
        >
          <ListItemText primary={props.menuItemConfig.label} />
          {props.openCascadeMenu[props.menuItemConfig.key] ? <ExpandMore /> : <ChevronRight />}
        </HamburgerMenuListItem>
        <Collapse in={props.openCascadeMenu[props.menuItemConfig.key]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {props.menuItemConfig.childItems.map((childItem) => renderChildMenuItem(childItem))}
          </List>
        </Collapse>
      </>
    );
  };

  const renderChildMenuItem = (childItemConfig) => {
    return childItemConfig.isActiveOnMobile
      ? childMenuItem(childItemConfig)
      : props.isDesktopView
      ? childMenuItem(childItemConfig)
      : "";
  };

  const childMenuItem = (childItemConfig) => {
    if (childItemConfig.isHamburgerOption) {
      return (
        <HamburgerMenuListItem
          key={childItemConfig.key}
          menuItemConfig={childItemConfig}
          onClick={() => props.onChildMenuItemClick()}
          selected={props.selectedMenuItem === childItemConfig.path}
          isChild={true}
          isDesktopView={props.isDesktopView}
        >
          <ListItemText primary={childItemConfig.label} />
        </HamburgerMenuListItem>
      );
    }
  };

  return props.menuItemConfig.isActiveOnMobile
    ? renderParentMenuItem()
    : props.isDesktopView
    ? renderParentMenuItem()
    : "";
};

export default HamburgerMenuCollapsibleMenuItem;
